import { ActionType, createAsyncAction } from 'typesafe-actions'
import { DepartmentState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchActiveDepartmentsAction = createAsyncAction(
  '@department/FETCH_ACTIVE_DEPARTMENTS_REQUEST',
  '@department/FETCH_ACTIVE_DEPARTMENTS_SUCCESS',
  '@department/FETCH_ACTIVE_DEPARTMENTS_FAILURE'
)<Request, Success, Failure>()

const request = (state: DepartmentState): DepartmentState => ({
  ...state,
  isLoadingFetchActiveDepartments: true
})

const success = (
  state: DepartmentState,
  action: ActionType<typeof fetchActiveDepartmentsAction.success>
): DepartmentState => {
  return {
    ...state,
    activeDepartments: action.payload?.departments || [],
    isSuccessFetchActiveDepartments: true,
    isLoadingFetchActiveDepartments: false
  }
}

const failure = (
  state: DepartmentState,
  { payload }: ReturnType<typeof fetchActiveDepartmentsAction.failure>
): DepartmentState => {
  return {
    ...state,
    isLoadingFetchActiveDepartments: false,
    isErrorFetchActiveDepartments: true
  }
}

export const fetchActiveDepartmentsHandle = {
  asyncAction: fetchActiveDepartmentsAction,
  request,
  success,
  failure
}
